/*global Modernizr, Splide, TLASlideCurrentSlide, TLASlideHideArrows, TLASlideDisableDrag */
/*jslint browser:true */

(function() {
    'use strict';

    var homepage_slider = document.getElementById('homepage-slider');
    if(homepage_slider) {
      const slider = new Splide(homepage_slider, {
        type: 'loop',
        pagination: false
      });

      slider.on('mounted resize', () => {
        if(slider.length <= slider.options.perPage) {
          slider.root.querySelector('.splide__arrows').classList.add('page-less');
        } else {
          slider.root.querySelector('.splide__arrows').classList.remove('page-less');
        }
      });

      slider.mount({ TLASlideCurrentSlide, TLASlideDisableDrag });
    }
}());
